<h2 mat-dialog-title>Enviar WhatsApp</h2>
<div mat-dialog-content class="whatsapp-edit">
  <form [formGroup]="form">
    <div>
      <label>Para</label>
      <input formControlName="to" placeholder="Número ou destinatário" />
    </div>

    <div>
      <label>Mensagem</label>
      <textarea formControlName="message" rows="6"></textarea>
    </div>

    <!-- Checkbox 'enviar assunto' removido -->

    <div>
      <label>Anexos (mídia)</label>
      <input type="file" (change)="onFilesSelected($event)" multiple />
    </div>

    <div *ngIf="attachments.length">
      <h4>Anexos</h4>
      <ul>
        <li *ngFor="let a of attachments; let i = index">
          {{ a.name }} ({{ a.size }} bytes)
          <button type="button" (click)="removeAttachment(i)">Remover</button>
        </li>
      </ul>
    </div>
  </form>
</div>
<div mat-dialog-actions align="end">
  <button mat-button (click)="cancel()">Fechar</button>
  <button mat-flat-button color="primary" (click)="send()" [disabled]="sending">
    <mat-progress-spinner *ngIf="sending" [diameter]="18" mode="indeterminate" class="sending-spinner"></mat-progress-spinner>
    {{ sending ? 'Enviando...' : 'Enviar' }}
  </button>
</div>
